/**
 * @generated SignedSource<<a54ab8f2ac7bbd765bc70993fb589325>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsListWithoutNavigation_participativeModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsList_participativeModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsListFilters_participativeModule"
    }
  ],
  "type": "ParticipativeModule",
  "abstractKey": null
};

node.hash = "f28339aa843cf18d11c373acc55b985b";

module.exports = node;
